import type { FC } from 'react';

import MetricCard from '@/common-components/MetricCard';
import type { AnalyticsOverview } from '@/types/stats.types';
import { formatRupees } from '@/utils/currency.util';

interface AnalyticsMetricsProps {
  analytics: AnalyticsOverview;
}

/**
 * The prototype's four cards were D30 retention, average session, fraud rate and average coins
 * per user. Shoutt tracks no sessions, no retention cohorts and no fraud signal, so these are the
 * four equivalents that are actually computable — same grid, real numbers.
 */
const AnalyticsMetrics: FC<AnalyticsMetricsProps> = ({ analytics }) => (
  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
    <MetricCard
      icon="🔁"
      label="Signup Conversion"
      value={`${analytics.signupConversionPct}%`}
      accent="brand"
      change="Verified → finished setup"
    />
    <MetricCard
      icon="✅"
      label="Rental Completion"
      value={`${analytics.rentalCompletionPct}%`}
      accent="success"
      change="Completed vs cancelled"
    />
    <MetricCard
      icon="💰"
      label="Avg. Rental Value"
      value={formatRupees(analytics.avgRentalValuePaise)}
      accent="info"
      change="Across completed rentals"
    />
    <MetricCard
      icon="🪙"
      label="Coin Redemption"
      value={`${analytics.coinEconomy.redemptionPct}%`}
      accent="pink"
      change={
        analytics.coinEconomy.netVelocity >= 0
          ? `+${analytics.coinEconomy.netVelocity.toLocaleString('en-IN')} net`
          : `${analytics.coinEconomy.netVelocity.toLocaleString('en-IN')} net`
      }
      changeTone={analytics.coinEconomy.netVelocity >= 0 ? 'up' : 'down'}
    />
  </div>
);

export default AnalyticsMetrics;
